import { Consulta } from './consulta';

export class ConsultaComposta {

  combinada: boolean;
  consultas: Consulta[];
  id: number;
  idCombinada: number;
  nome: string;
  status: boolean;
  checked = false;
  disabled = false;
  possuiConsultaCredito = false;
  idUnidade: number;
  uuid: string;

  constructor(c:any = []) {
    this.combinada = c['combinada'] || false;
    this.id = c['id'] || null;
    this.idCombinada = c['idCombinada'] || null;
    this.nome = c['nome'] || '';
    this.status = c['status'] || false;
    this.checked  = c['checked'] || false;
    this.disabled  = c['disabled'] || false;
    this.consultas = c['consultas'] ? c['consultas'].map(r => new Consulta(r)) : [];
    this.idUnidade  = c['idUnidade'] || -1;
    this.uuid = c['uuid'] || '';
  }

}
